import { z } from 'zod';

export interface Message {
  readonly id: string;
  readonly applicationId: string;
  readonly senderId: string;
  readonly body: string;
  readonly createdAt: string;
}

const rowSchema = z.object({
  id: z.string(),
  application_id: z.string(),
  sender_id: z.string(),
  body: z.string(),
  created_at: z.string(),
});

export function mapMessage(row: unknown): Message {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    applicationId: r.application_id,
    senderId: r.sender_id,
    body: r.body,
    createdAt: r.created_at,
  };
}
